import { useEffect, useRef } from 'react'

/** La cat se reimprospateaza tabloul ADM - `setInterval(..., 30000)` din `public/js/adm.js`. */
export const ADM_REFRESH_MS = 30_000

/**
 * Reimprospatarea pe ceas a tabloului de descoperire (cerinta 91) - perechea
 * blocului din `public/js/adm.js:1075-1090` din portalul vechi.
 *
 * Trei lucruri pe care `setInterval`-ul de acolo nu le facea:
 *
 *  - NU CERE CAT TAB-UL E ASCUNS (`document.visibilityState`). Un tablou lasat
 *    deschis intr-un tab din spate cerea la 30 de secunde, toata noaptea, de la
 *    fiecare om. Cand tab-ul revine si ultima citire e mai veche de un ceas,
 *    se cere o data, imediat - omul care se intoarce vede cifrele de acum.
 *  - NU SUPRAPUNE CERERI. Daca raspunsul intarzie peste 30 de secunde, bataia
 *    urmatoare se sare in loc sa mai porneasca una; altfel un server incet
 *    primea tot mai multe cereri exact cand le ducea mai greu.
 *  - SE POATE OPRI (`enabled`), din bifa de pe ecran.
 *
 * `refresh` trebuie sa intoarca o promisiune care se incheie cand s-a terminat
 * cererea (de ex. `query.refetch({ cancelRefetch: false })`).
 */
export function useAutoRefresh(enabled: boolean, refresh: () => Promise<unknown>, everyMs: number = ADM_REFRESH_MS): void {
  const inFlight = useRef(false)
  const last = useRef(Date.now())
  const latest = useRef(refresh)
  latest.current = refresh

  useEffect(() => {
    if (!enabled) return

    const run = () => {
      if (inFlight.current) return
      if (typeof document !== 'undefined' && document.visibilityState !== 'visible') return
      inFlight.current = true
      last.current = Date.now()
      latest
        .current()
        .catch(() => undefined)
        .finally(() => {
          inFlight.current = false
        })
    }

    const timer = setInterval(run, everyMs)
    const onVisible = () => {
      if (document.visibilityState === 'visible' && Date.now() - last.current >= everyMs) run()
    }
    document.addEventListener('visibilitychange', onVisible)

    return () => {
      clearInterval(timer)
      document.removeEventListener('visibilitychange', onVisible)
    }
  }, [enabled, everyMs])
}
